/**
 * Guard for the vendor libraries the components expect as globals
 *
 * theme.js is one IIFE. A component that touches a library the page did not
 * load (the bundles are conditional, see browser/layoutpolicy.py) throws a
 * ReferenceError, and every component bundled after it never runs - one
 * missing lightGallery used to take the carousels, tooltips, form validation,
 * the price switch and the countdown down with it.
 *
 * Callers pass `typeof <global>` per name, written out at the call site:
 * `typeof` is the one read of an undeclared identifier that does not throw,
 * and it also sees globals declared with a top-level let/const, which a
 * `window[name]` lookup would miss.
 *
 *   if (vendorMissing('gallery', { lightGallery: typeof lightGallery })) return
 *
 * Returns true (and warns once per feature) when anything is missing; the
 * caller then skips only its own feature.
 */

const warned = {}

export default (feature, types) => {
  const missing = Object.keys(types).filter(
    (name) => types[name] === 'undefined'
  )
  if (missing.length === 0) return false
  if (!warned[feature] && typeof console !== 'undefined') {
    warned[feature] = true
    console.warn(
      `booost theme: ${feature} skipped, ${missing.join(', ')} not loaded`
    )
  }
  return true
}
